import OpenAI from 'openai';

export const createOpenAIClient = (opts: {
    apiKey?: string;
    dangerouslyAllowBrowser?: boolean;
    organization?: string;
}): AIClient => {
    const { apiKey, dangerouslyAllowBrowser, organization } = opts;

    if (!apiKey) {
        return createStubAIClient('Missing OpenAI environment variables: define OPENAI_API_KEY');
    }

    return new OpenAIClient(new OpenAI({ apiKey, dangerouslyAllowBrowser, organization }));
};

export function createStubAIClient(errorMessage: string): AIClient {
    return { textCompletion: (_) => Promise.reject(errorMessage) };
}

export type TextCompletionOpts = Partial<OpenAI.CompletionCreateParams>;

export type AIClient = {
    textCompletion: (prompt: string, completionOpts?: TextCompletionOpts) => Promise<string>;
};

export class OpenAIClient implements AIClient {
    constructor(private readonly openAIApi: OpenAI) {}

    async textCompletion(prompt: string, completionOpts?: TextCompletionOpts): Promise<any> {
        let response: OpenAI.Completion;

        try {
            response = (await this.openAIApi.completions.create({
                model: 'text-davinci-003',
                prompt,
                ...completionOpts,
            })) as OpenAI.Completion;
        } catch (e: any) {
            throw Error('OpenAI text completion failed: ' + JSON.stringify(e));
        }

        const text = response.choices?.[0]?.text;

        if (!text) {
            throw Error('Invalid OpenAI text completion response: ' + JSON.stringify(response));
        }

        return text.trimStart();
    }
}
